<!--note: mt,mb,ml,mr(margin) pada class jangan diubah-->
<template>
  <div class="content" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''">
    <v-snackbar v-model="alertSuccess" :timeout="4000" top right color='primary' >
        <v-icon x-medium class="white--text">mdi-checkbox-marked-circle</v-icon>    <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-snackbar v-model="alertFailed" :timeout="4000" top right color='red' >
      <v-icon x-medium class="white--text">mdi-minus-circle</v-icon>   <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-breadcrumbs :items="pages" class="ml-2 mt-0 pt-0"></v-breadcrumbs>
        <!-- <v-row class="mx-4"> -->
          <template >
            <v-toolbar flat class="rounded-lg">
              <v-toolbar-title style="margin-left: 20px;"><v-icon class="mr-2">mdi-earth</v-icon>List Bot Target</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" max-width="800px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn  v-show=insertact outlined rounded small color="primary" class="mb-2" v-bind="attrs" v-on="on">
                    Add New Bot Target
                    <v-icon class="ml-2">mdi-plus</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <v-card-title><span class="text-h6">{{ formTitle }}</span></v-card-title>
                  </v-card-title>
                  <v-card-text style="height: auto;" class="overflow-card">
                      <v-form class="ml-2" ref="form" lazy-validation>
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="12" md="12">
                              <v-select 
                              :items="listBot" 
                              item-text="name_bot" 
                              item-value="valuebot" 
                              label="Bot ID" 
                                hint="Select Bot ID" persistent-hint
                              v-model="idbotaccount"
                              ></v-select>
                            </v-col> 
                            <v-col cols="10" sm="10" md="10">
                              <v-select 
                              @change="valueAccount(account)"
                              :items="listAccount" 
                              item-text="name_person" 
                              item-value="valueperson" 
                              label="Famous Person" 
                              hint="Select Famous Person" persistent-hint
                              v-model="account"
                              ></v-select>
                            </v-col> 
                            <v-col cols="2" sm="2" md="2">
                                <v-btn class="mx-2 elevation-0" dark outlined color="#0471A5" @click="addResultAccount()"><v-icon >mdi-plus</v-icon></v-btn>
                            </v-col> 
                            <v-col cols="12" sm="12" md="12">
                              <v-chip-group column> 
                                  <div v-for="(item, i) in resultAccountWithId" :key="i">
                                    <v-chip  class="ma-2" close @click:close="closeChip(item)">{{item.USER_ID}}</v-chip>  
                                  </div>
                                </v-chip-group>
                            </v-col> 
                          </v-row>
                        </v-container>
                      </v-form>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="py-3">
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
                      Cancel
                    </v-btn>
                    <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense :loading="btnload" @click="save">
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>

              </v-dialog>

              <v-dialog v-model="dialogDelete" width="330px">
                <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
                  <v-avatar class="color-avatar3 my-4" size="62">
                    <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
                  </v-avatar>
                  <div class="text-center text-h6 align-center justify-center font-weight-medium">
                    Confirm Deletion
                  </div>
                  <v-card-text class="align-center justify-center mt-2">
                    Are you sure you want to permanently delete this item?
                  </v-card-text>

                  <v-divider class="mt-4" style=""></v-divider>

                  <v-card-actions class="align-center justify-center">
                    <v-btn rounded class="my-3 btn-ok" width="90px" dark @click="deleteItemConfirm">
                      OK
                    </v-btn>
                    <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDelete">
                      Cancel 
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              
            </v-toolbar>
          </template>
          <!--Card Expand1-->
          <v-flex lg12 class="mx-4 mb-4" 
          :items="bottarget"  :search="search" v-for="item in bottarget" :key="item.id">
            <v-expansion-panels focusable>
              <v-expansion-panel>
                <v-expansion-panel-header>{{ item.ACCOUNT_ID }} </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-list-item-content>
                      <v-row class="ma-4">
                        <v-flex xs12 sm12 md12 lg12>
                          <v-card-text class="font-weight-bold">Person ID:</v-card-text>
                          <v-card-text>
                            <div>
                              <span  v-for="sub in item.PERSON"  :key="sub.person_id">{{ sub.USER_ID }},</span>
                            </div>
                          </v-card-text>
                          <v-card-text class="font-weight-bold">Action</v-card-text>
                          <v-btn rounded small class="elevation-0 ml-2" color="success" v-show=updateact  @click="editItem(item.BOT)">Update</v-btn>
                          <v-btn rounded small class="elevation-0 mx-2" dark color="red" v-show=deleteact  @click="deleteItem(item.BOT)">Delete</v-btn>
                        </v-flex>
                      </v-row>
                    </v-list-item-content>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
          </v-flex>
        <!-- </v-row> -->
        <v-flex>
          <v-spacer></v-spacer>
          <div align="center" justify="center" class="my-8">
            <v-pagination color="#0471A5" 
            v-model="page" 
            :length="pagelength"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            @input="handlePageChange"
            ></v-pagination>
          </div>
        </v-flex>
    <Notification  ref="alert"></Notification>
  </div>
</template>
<script>
import axios from "axios";
import { decryptionData } from '@/components/utils/utils.js';
import Notification from  '@/components/Notification';
import { mapGetters } from 'vuex';
  export default {
    components: {
      Notification: Notification
    },
    data () {
      return {
        btnload:false,
        alertSuccess:'',
        alertFailed:'',
        alert_err_attention: "",
        
        deleteact: false,
        insertact: false,
        updateact: false,
        viewact: false,
        
        isAdd: false,
        indexDelete: [],
        search:'',
        seq_id:'',
        bottarget: [],
        tmpbottarget: [],
        
        resultAccount: [],
        resultAccountWithId: [],
        listBot: [
          {
            name_bot: '', 
            valuebot: '' 
          }
        ],
        listAccount: [
          {
            name_person: '', 
            valueperson: '' 
          }
        ],
        editedItem: {},
        
        pagelength :1,
        pageplay:0,
        limit_page:4,
        page: 1,
        dialog: false,
        dialogDelete: false,
        editedIndex: -1,
        pages: [
        {
          text: 'Home',
          disabled: false,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Twitter',
          disabled: false,
          href: 'breadcrumbs_link_1',
        },
        {
          text: 'Bot Target',
          disabled: false,
          href: 'breadcrumbs_link_2',
        },
      ],
      }
    },
    computed: {
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
      formTitle () {
        return this.editedIndex === -1 ? 'Add Bot Target' : 'Edit Bot Target'
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    created () {
      this.initialize()
    },
    methods: {
      initialize () {
        axios.get("bot-target?page_v=" + this.pageplay + "&limit_v=" + this.limit_page,
          {headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            
            const data = decryptionData(response.data.token);
            this.tmpbottarget = data.result;
            this.bottarget = data.result;
            this.pagelength = data.totalPage;
            let result = '';
              let arr_data = [];
              if(data.data_person.length > 0){
                for (let i = 0; i <  data.data_person.length; i++) {  
                    if(i == 1){
                      this.data_person_id = (data.data_person[i].SEQ_ID);
                    }
                    result = {
                      valueperson : data.data_person[i].SEQ_ID,
                      name_person  : data.data_person[i].USER_ID
                    };
                    arr_data.push(result);
                }
                this.listAccount= arr_data;
              }

              this.resultAccount = data.data_person  
              this.isAdd = false
            let result_bot = '';
              let arr_data_bot = [];
              if(data.data_bot.length > 0){
                for (let i = 0; i <  data.data_bot.length; i++) {  
                    if(i == 1){
                      this.data_bot_id = (data.data_bot[i].id);
                    }
                    result_bot = {
                      valuebot : data.data_bot[i].id,
                      name_bot : data.data_bot[i].name
                    };
                    arr_data_bot.push(result_bot);
                }
                console.log(arr_data_bot);
                this.listBot= arr_data_bot;
              }
            setTimeout(() =>{
              this.loading = false
            },1000)
            
            if(localStorage.getItem('authactdeletedt') == 1){ this.deleteact = true }
            if(localStorage.getItem('authactinsert') == 1){ this.insertact = true }
            if(localStorage.getItem('authactupdate') == 1){ this.updateact = true }
            if(localStorage.getItem('authactview') == 1){ this.viewact = true }
          })
          .catch((e) => {
              switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
          this.errors=e.data.msg;
        });
      },

      async handlePageChange(value) {
        this.pageplay = value - 1;
        this.initialize();
      },
      close () {
        this.seq_id='';
        this.idbotaccount='';
        this.resultAccountWithId = []
        this.resultrealAccount = []

        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      
      valueAccount(account){  
        const uuidv4 = require('uuid/v4');     
        this.uniqueId = uuidv4()
        console.log(account);
      },

      addResultAccount(){
        if(this.account == ''){ 
          this.alertFailed = true;
          this.alert_err_attention =  "Account has been add";
        }
        if(this.resultAccount.includes(this.account)){
          this.alertFailed = true;
          this.alert_err_attention =  "Account has been add";
        }if(!this.resultAccount.includes(this.account)){       
          this.isAdd = true     
          this.resultAccountWithId.forEach((elm) => {
            if(elm["PERSON_ID"] == this.account){
              
            this.addvalPinned = -1
            }else{

              this.addvalPinned = 1
            }
          });
          
          if( this.addvalPinned == -1){
              this.alertFailed = true;
              this.alert_err_attention =  "Account has been exist";
          }else{
              this.resultAccount.forEach((element) => {
                if(element["SEQ_ID"] == this.account){
                  this.resultAccountWithId.push({"ADD": true,"SEQ_ID": "PRS"+this.account,"USER_ID": element["USER_ID"], "PERSON_ID": this.account});
                  this.resultrealAccount.push({"ADD": true,"SEQ_ID": "PRS"+this.account,"USER_ID": element["USER_ID"], "PERSON_ID": this.account})
                }
              });
          }
        }
      },
      
      
      editItem (item) {
        // alert(item);
        // this.id_organization = item
        this.resultAccountWithId = []
        this.resultrealAccount = []

        this.editedIndex = 1
        this.seq_id = item;
        this.idbotaccount = item;
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        axios({
          method: "put",
          url: "/bot-target/byBotid",
          data: {
            bot_id: item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            // console.log(response.data[0].PERSON);
            
            const data = decryptionData(response.data.token);
            const person_detail = data[0].PERSON;
       
            let arr_data = [];
            if(person_detail.length > 0){
              for (let i = 0; i <  person_detail.length; i++) { 
                  arr_data.push(person_detail[i].NER_ALIAS);
                  this.resultAccountWithId.push({"ADD": true,"SEQ_ID": "PRS"+i,"USER_ID": person_detail[i].USER_ID, "PERSON_ID": person_detail[i].PERSON_ID});
                  this.resultrealAccount.push({"ADD": true,"SEQ_ID": "PRS"+i,"USER_ID": person_detail[i].USER_ID, "PERSON_ID": person_detail[i].PERSON_ID})
              }
              
            }else{
                  this.arr_alias =[];
            }
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      },
      closeChip(item){ 
        this.indexDelete.push(item.SEQ_ID)
        console.log(item);
        this.isAdd = true  
        if( item.ADD == true){
          // alert('aaa');
          this.resultAccountWithId = removeObjectWithId(this.resultAccountWithId, item.SEQ_ID);
          this.resultrealAccount = removeObjectWithIdAccount(this.resultrealAccount, item.SEQ_ID);
        }else{
          axios({
            method: "delete",
            url: "/pinned_account/delete",
            data: {
              id_pinned: item.SEQ_ID
            },
            headers:{'auth-token':localStorage.getItem('token_app')},
            dataType: 'json'
          })
          .then((response) => {
            // handle success
            console.log(response);
          })
          .catch(function (error) {
            console.log(error);
          })
          this.resultAccountWithId = removeObjectWithId(this.resultAccountWithId, item.SEQ_ID);
        }
        function removeObjectWithId(arr, id) {
        return arr.filter((obj) => obj.SEQ_ID !== id);
        }
          function removeObjectWithIdAccount(arr, id) {
          return arr.filter((obj) => obj.SEQ_ID !== id);
        }
      },
      async save(){
        this.btnload = true
        if(this.resultAccountWithId.length > 0 || this.isAdd == true){
          axios.post("/bot-target/action", 
            {
              seq_id :this.seq_id,
              bot_id :this.idbotaccount,
              person_id :this.resultAccountWithId
              
            },
            { headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
              console.log(response)   
              
              this.dialog = false
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.initialize() 
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.close()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
              } 
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    case 400:
                          this.alertFailed = true;
                          this.alert_err_attention =  'Failed';
                          this.btnload = false
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });   
        }else{
            this.alertFailed = true;
            this.alert_err_attention =  "Account has not been added";
            this.btnload = false
        }                
      },
      deleteItem (item) {
        this.bot_id = item
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        
        axios({
          method: "delete",
          url: "/bot-target/delete",
          data: {
            bot_id: this.bot_id
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          // handle success
            var status = response.data.status
            var messages = response.data.msg
            if(status == 200){
              this.initialize ();
              this.alertSuccess = true;
              this.alert_err_attention =  messages;
              this.closeDelete()
            }else{
                this.alertFailed = true;
                this.alert_err_attention =  messages;
            } 
        })
        .catch(function (error) {
          // handle error
          this.alertFailed = true;
          this.alert_err_attention =  'Delete Failed '+error;
          this.closeDelete()
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedIndex = -1
        })
      },



    },
  }
</script>